import { registerModuleReducer } from 'utils/modules/reducer';

import reducer from './reducers';
import UnsyncableRecipientsModal from './unsyncable-recipients-modal';

registerModuleReducer('unsyncableRecipientsModal', reducer);

export default UnsyncableRecipientsModal;
